import React, { useContext, useEffect } from 'react';
import { ThemeContext } from '../../context/ThemeContext';

import 'react-datepicker/dist/react-datepicker.css'; // DatePicker 스타일 추가

const BlockScreen: React.FC = () => {
	const { theme } = useContext(ThemeContext)

	useEffect(() => {
		// 백버튼 초기화
		const initializeTgBack = async () => {
			
		}
		
		initializeTgBack()

	}, [])
	
	const styles = {
		container: {
			padding: "0px 0px 0",
		} as React.CSSProperties,
		modalBackground: {
			display: "flex",
			justifyContent: 'center',
			alignItems: 'center',
			width: "100%",
			height: "100%",
			padding: "0px 0px 0px 0px",
		} as React.CSSProperties,
		forgotPassword: {
			display: "flex",
			justifyContent: 'center',
			alignItems: 'center',
			width: "100%",
			height: "70px",
		} as React.CSSProperties,
		title1: {
			fontSize: 24,
			textAlign: 'center',
		} as React.CSSProperties,
	}

	return (
		<div className='container' style={{ ...styles.container, backgroundColor: theme.background_normal }}>
			<div className='modalbackground' style={styles.modalBackground}>
                PC 환경에서 실행 불가
				{/* {fingerprintEnabled ? (
					<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' ,color: 'white', fontWeight:"bold" }}>
						'FingerPrint UI'
					</div>
				) : (
					<PinCodeScreen onSuccess={handlePinCodeintAuthSuccess} unlock={true} />
				)} */}
			</div>
			<div className='forgotPassword' style={styles.forgotPassword}>
				
			</div>
		</div>
	)
}

export default BlockScreen
